<template>
    
  <loader v-if="isLoading == true" name="spinning" loadingText="Cargando..." textColor="#ffffff" textSize="20" textWeight="500" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" :disableScrolling="true"></loader>
   
<hr>
    <h3 style="text-align: left;">Testigo 1</h3>
    
    <div>
        <div class="py-3 col-md-12 row">
            <div class="col-md-3">
                <label for="">Nombre</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.nombre"/>
                <label class="is-invalid">{{ validation.nombre }}</label>
            </div>
            <div class="col-md-3">
                <label for="">Tipo identificacion</label><span class="is-invalid">*</span>
            
                <select
                    class="form-control"
                    v-model="form.tipo_identificacion"
                    @change="actualizarExpide"
                >
                    <option value="">Seleccione una identificación</option>
                    <option value="CREDENCIAL PARA VOTAR">CREDENCIAL PARA VOTAR</option>
                    <option value="PASAPORTE">PASAPORTE</option>
                    <option value="CURP">CURP</option>
                </select>
                <label class="is-invalid">{{ validation.tipo_identificacion }}</label>
                
            </div>
            <div class="col-md-3">
                <label for="">Expedida por</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.expedida_por" readonly />
                
                <label class="is-invalid">{{ validation.expedida_por }}</label>

                
            </div>
            <div class="col-md-3">
                <label for="">Numero</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.numero"/>
                <label class="is-invalid">{{ validation.numero }}</label>
            </div>
        </div>
        <div class="py-3 col-md-12 row">
            <div class="col-md-3">
                <label for="">Identificacion <span class="is-invalid">*</span> Tamaño máximo 5 MB</label>

                
                <input
    type="file"
    @change="onFileChange($event)"
    accept="image/*,.pdf,application/pdf"
    class="form-control"
/>
                <label class="is-invalid">{{ validation.identificacion_imagen }}</label>
                <br>
                <!--<div v-if="imagePreview" class="col-md-4 text-center">
                    <img :src="imagePreview" alt="Vista previa de la imagen" id="imagencat" width="150" @click="eliminarImagen()">
                </div>-->
                <div v-if="imagePreview" class="col-md-4 text-center">
                    <div v-if="isImage1">
                        <img :src="imagePreview" alt="Vista previa de la imagen" id="imagencat" width="150" @click="eliminarImagen()">
                    </div>
                    <div v-else-if="isPdf1">
                        <iframe :src="imagePreview" type="application/pdf" width="300" height="200" />
                    </div>
                    <!--<img :src="imagePreview2" alt="Vista previa de la imagen" id="imagencat" width="150" @click="eliminarImagen()">-->
                </div>
            </div>
        </div>
    </div>
    <hr>
    <h3>Testigo 2</h3>
    <div>
        <div class="py-3 col-md-12 row">
            <div class="col-md-3">
                <label for="">Nombre</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.nombreSeg"/>
                <label class="is-invalid">{{ validation.nombreSeg }}</label>
            </div>
            <div class="col-md-3">
                <label for="">Tipo identificación</label><span class="is-invalid">*</span>
                
                <select
                    class="form-control"
                    v-model="form.tipo_identificacionSeg"
                    @change="actualizarExpideSeg"
                >
                    <option value="">Seleccione una identificación</option>
                    <option value="CREDENCIAL PARA VOTAR">CREDENCIAL PARA VOTAR</option>
                    <option value="PASAPORTE">PASAPORTE</option>
                    <option value="CURP">CURP</option>
                </select>
                <label class="is-invalid">{{ validation.tipo_identificacionSeg }}</label>
            </div>
            <div class="col-md-3">
                <label for="">Expedida por</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.expedida_porSeg" readonly/>
                <label class="is-invalid">{{ validation.expedida_porSeg }}</label>
            </div>
            <div class="col-md-3">
                <label for="">Numero</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.numeroSeg"/>
                <label class="is-invalid">{{ validation.numeroSeg }}</label>
                
            </div>
        </div>
        <div class="py-3 col-md-12 row">
            <div class="col-md-3">
                <label for="">Identificación<span class="is-invalid">*</span> Tamaño máximo 5 MB</label><br>
                
                
                
                <input
                    type="file"
                    @change="onFileChangeTestigo($event)"
                    accept="image/*,.pdf,application/pdf"
                    class="form-control"
                />
                <label class="is-invalid">{{ validation.identificacion_imagenSeg }}</label>
                <br>
                
                <div v-if="imagePreview2" class="col-md-4 text-center">
                    <div v-if="isImage2">
                        <img :src="imagePreview2" alt="Vista previa de la imagen" id="imagencat" width="150" @click="eliminarImagen()">
                    </div>
                    <div v-else-if="isPdf2">
                        <iframe :src="imagePreview2" type="application/pdf" width="300" height="200" />
                    </div>
                    <!--<img :src="imagePreview2" alt="Vista previa de la imagen" id="imagencat" width="150" @click="eliminarImagen()">-->
                </div>

                <div v-if="imagePreview2" class="text-center mt-2">

    <div v-if="isImage">
        <img
            :src="imagePreview2"
            alt="Vista previa"
            width="150"
        >
    </div>

    <div v-if="isPdf">
        <iframe
            :src="imagePreview2"
            width="500"
            height="400"
            style="border: 1px solid #ccc;"
        ></iframe>
    </div>

</div>
            </div>
        </div>
    </div>
   
    <hr>
    <button type="button" v-if="existeInformacion == false" class="btn" style="background-color: #F49315; color: white;" @click="guardar">Guardar Información de testigos</button>
    <button type="button" v-if="existeInformacion == true" class="btn btn-warning" @click="actualizar">Actualizar Información de testigos</button>

    </template>
    <script>
    import axios from 'axios';
    import Swal from 'sweetalert2';
    export default {
        data() {
            return {
                isLoading:false,
                existeInformacion:false,
                isButton1Disabled: false,
                isButton2Disabled: true,
                form:{
                    nombre:'',
                    identificacion:'',
                    expedida_por:'',
                    numero:'',
                    tipo_identificacion:'',
                    identificacion_imagen:'',
                    usuario:'',
                    idcotizacion:"",
                    id:"",

                    nombreSeg:'',
                    identificacionSeg:'',
                    expedida_porSeg:'',
                    numeroSeg:'',
                    tipo_identificacionSeg:'',
                    identificacion_imagenSeg:'',
                    usuarioSeg:'',
                    idcotizacionSeg:"",
                    idSeg:""
                },
                validation:{
                  
                    nombre:"",
                    tipo_identificacion:"",
                    expedida_por:"",
                    numero:"",
                    identificacion_imagen:"",

                    nombreSeg:"",
                    tipo_identificacionSeg:"",
                    expedida_porSeg:"",
                    numeroSeg:"",
                    identificacion_imagenSeg:""
                },
                existeInformacion:false,
                imageFile1:null,
                imagePreview:null,
                imageFile2:null,
                imagePreview2:null,

                
        
            }  
        },
        created() {
            this.consultar();
        },
        computed: {
             isImage1() {
                return this.imageFile1 && this.imageFile1.type.startsWith('image/');
            },

            isPdf1() {
                return this.imageFile1 && this.imageFile1.type === 'application/pdf';
            },

            isImage2() {
                return this.imageFile2 && this.imageFile2.type.startsWith('image/');
            },

            isPdf2() {
                return this.imageFile2 && this.imageFile2.type === 'application/pdf';
            }
        },
        methods: {
            cargarTipoArchivo(archivo, testigo) {
    if (!archivo) {
        return;
    }

    if (testigo == 1) {
        this.imagePreview = this.$rutaImagenes + archivo;

        if (archivo.toLowerCase().endsWith('.pdf')) {
            this.imageFile1 = {
                type: 'application/pdf'
            };
        } else {
            this.imageFile1 = {
                type: 'image/*'
            };
        }
    }

    if (testigo == 2) {
        this.imagePreview2 = this.$rutaImagenes + archivo;

        if (archivo.toLowerCase().endsWith('.pdf')) {
            this.imageFile2 = {
                type: 'application/pdf'
            };
        } else {
            this.imageFile2 = {
                type: 'image/*'
            };
        }
    }
},
            actualizarExpideSeg() {
                const expedidoPor = {
                    'CREDENCIAL PARA VOTAR': 'INE',
                    'PASAPORTE': 'SER',
                    'CURP': 'SEGOB',
                };

                this.form.expedida_porSeg = expedidoPor[this.form.tipo_identificacionSeg] || '';
            },
            actualizarExpide() {
                const expedidoPor = {
                    'CREDENCIAL PARA VOTAR': 'INE',
                    'PASAPORTE': 'SER',
                    'CURP': 'SEGOB',
                };

                this.form.expedida_por = expedidoPor[this.form.tipo_identificacion] || '';
            },
            onFileChange(event) {

    const file = event.target.files[0];

    if (
        file &&
        (file.type.startsWith('image/') ||
         file.type === 'application/pdf')
    ) {

        this.imageFile1 = file;
        this.imagePreview = URL.createObjectURL(file);

    } else {

        this.imageFile1 = null;
        this.imagePreview = null;
    }
},
            previewImage(file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imagePreview = e.target.result;
                };
                reader.readAsDataURL(file);
            },
            /*onFileChangeTestigo (event) {
                const file = event.target.files[0];
                //if (file && file.type.startsWith('image/')) {
                if(file && (file.type.startsWith('image/') || file.type === 'application/pdf')){

                    this.imageFile2= file;
                    this.previewImageTestigo(file);
                } else {
                    this.imageFile2 = null;
                    this.imagePreview2 = null;
                }
            },*/
            /*previewImageTestigo(file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imagePreview2 = e.target.result;
                };
                reader.readAsDataURL(file);
            },*/

           onFileChangeTestigo(event) {

    const file = event.target.files[0];

    if (
        file &&
        (file.type.startsWith('image/') ||
         file.type === 'application/pdf')
    ) {

        this.imageFile2 = file;
        this.imagePreview2 = URL.createObjectURL(file);

    } else {

        this.imageFile2 = null;
        this.imagePreview2 = null;
    }
},
/*onFileChangeTestigo(event) {
    const file = event.target.files[0];

    if (file && (file.type.startsWith('image/') || file.type === 'application/pdf')) {

        // Máximo 5 MB
        if (file.size > 5 * 1024 * 1024) {
            this.imageFile2 = null;
            this.imagePreview2 = null;
            this.isImage = false;
            this.isPdf = false;

            this.validation.identificacion_imagenSeg = 'El archivo no debe superar los 5 MB.';
            return;
        }

        this.validation.identificacion_imagenSeg = '';

        this.imageFile2 = file;
        this.previewImageTestigo(file);

    } else {
        this.imageFile2 = null;
        this.imagePreview2 = null;
        this.isImage = false;
        this.isPdf = false;

        this.validation.identificacion_imagenSeg = 'Solo se permiten imágenes o archivos PDF.';
    }
},*/
            guardar() {
                var idcotizacion = localStorage.getItem('idcotizacion');
                var usuario = localStorage.getItem('email');

                this.form.idcotizacion = idcotizacion;
                this.form.usuario = usuario;
                this.form.numerotestigoSeg = 2;
                this.form.idcotizacionSeg = idcotizacion;
                this.form.usuarioSeg = usuario;

                const formData = new FormData();
           
                formData.append('nombre', this.form.nombre);
                formData.append('tipo_identificacion', this.form.tipo_identificacion); 
                formData.append('expedida_por', this.form.expedida_por); 
                formData.append('id', this.form.id); 
                formData.append('numero', this.form.numero); 
                formData.append('idcotizacion', this.form.idcotizacion); 
                formData.append('usuario', usuario); 


                formData.append('nombreSeg', this.form.nombreSeg);
                formData.append('tipo_identificacionSeg', this.form.tipo_identificacionSeg); 
                formData.append('expedida_porSeg', this.form.expedida_porSeg); 
                formData.append('idSeg', this.form.idSeg); 
                formData.append('numeroSeg', this.form.numeroSeg); 
                formData.append('idcotizacionSeg', this.form.idcotizacionSeg); 
                formData.append('usuarioSeg', usuario); 



                
                if(this.imageFile1){
                    formData.append('identificacion_imagen', this.imageFile1);
                }
                if(this.imageFile2){
                    formData.append('identificacion_imagenSeg', this.imageFile2);
                }
                axios.post(this.$rutaServer+'guardarTestigo', formData)
                .then(response => {
                    if (response.status == 201) {
                        Swal.fire('¡Éxito!', 'Datos registrados', 'success');
                        this.validation.nombre = '';
                        this.validation.tipo_identificacion = '';
                        this.validation.expedida_por = '';
                        this.validation.numero = '';
                        this.validation.identificacion_imagen = '';

                        this.validation.nombreSeg = '';
                        this.validation.tipo_identificacionSeg = '';
                        this.validation.expedida_porSeg = '';
                        this.validation.numeroSeg = '';
                        this.validation.identificacion_imagenSeg = '';
                        this.consultar();
                    }
                })
                .catch(error => {
                    if(error.response.data.errors?.nombre?.[0]){
                                this.validation.nombre = error.response.data.errors?.nombre?.[0];
                            }
                            if(error.response.data.errors?.tipo_identificacion?.[0]){
                                this.validation.tipo_identificacion = error.response.data.errors?.tipo_identificacion?.[0];
                            }
                            if(error.response.data.errors?.expedida_por?.[0]){
                                this.validation.expedida_por = error.response.data.errors?.expedida_por?.[0];
                            }
                            if(error.response.data.errors?.numero?.[0]){
                                this.validation.numero = error.response.data.errors?.numero?.[0];
                            }
                            
                            if(error.response.data.errors?.identificacion_imagen?.[0]){
                                this.validation.identificacion_imagen = error.response.data.errors?.identificacion_imagen?.[0];
                            }



                            if(error.response.data.errors?.nombreSeg?.[0]){
                                this.validation.nombreSeg = error.response.data.errors?.nombreSeg?.[0];
                            }
                            if(error.response.data.errors?.tipo_identificacionSeg?.[0]){
                                this.validation.tipo_identificacionSeg = error.response.data.errors?.tipo_identificacionSeg?.[0];
                            }
                            if(error.response.data.errors?.expedida_porSeg?.[0]){
                                this.validation.expedida_porSeg = error.response.data.errors?.expedida_porSeg?.[0];
                            }
                            if(error.response.data.errors?.numeroSeg?.[0]){
                                this.validation.numeroSeg = error.response.data.errors?.numeroSeg?.[0];
                            }
                            if(error.response.data.errors?.identificacion_imagenSeg?.[0]){
                                this.validation.identificacion_imagenSeg = error.response.data.errors?.identificacion_imagenSeg?.[0];
                            }
                            
                });
            },
            actualizar() {
                var idcotizacion = localStorage.getItem('idcotizacion');
                var usuario = localStorage.getItem('email');

                this.form.idcotizacionSeg = idcotizacion;
                this.form.usuario = usuario;
                this.form.idcotizacion = idcotizacion;
                this.form.usuarioSeg = usuario;
                this.form.numerotestigo = 1;
                this.form.numerotestigoSeg = 2;
                this.form.id = this.form.id;

                const formData = new FormData();
           
                formData.append('nombre', this.form.nombre);
                formData.append('tipo_identificacion', this.form.tipo_identificacion); 
                formData.append('expedida_por', this.form.expedida_por); 
                formData.append('id', this.form.id); 
                formData.append('numero', this.form.numero); 
                formData.append('idcotizacion', this.form.idcotizacion); 
                formData.append('usuario', usuario); 
                formData.append('numerotestigo', 1); 


                formData.append('nombreSeg', this.form.nombreSeg);
                formData.append('tipo_identificacionSeg', this.form.tipo_identificacionSeg); 
                formData.append('expedida_porSeg', this.form.expedida_porSeg); 
                formData.append('idSeg', this.form.idSeg); 
                formData.append('numeroSeg', this.form.numeroSeg); 
                formData.append('idcotizacionSeg', this.form.idcotizacionSeg); 
                formData.append('usuarioSeg', usuario); 
                formData.append('numerotestigoSeg', 2); 

                if (this.imageFile1 instanceof File) {
    formData.append('identificacion_imagen', this.imageFile1);
}

if (this.imageFile2 instanceof File) {
    formData.append('identificacion_imagenSeg', this.imageFile2);
}
                axios.post(this.$rutaServer+'actualizarRegistroTestigo', formData)
                .then(response => {
                    if (response.status == 200) {
                        Swal.fire('¡Éxito!', 'Datos actualizados', 'success');
                        this.validation.nombre = '';
                        this.validation.tipo_identificacion = '';
                        this.validation.expedida_por = '';
                        this.validation.numero = '';
                        this.validation.identificacion_imagen = '';

                        this.validation.nombreSeg = '';
                        this.validation.tipo_identificacionSeg = '';
                        this.validation.expedida_porSeg = '';
                        this.validation.numeroSeg = '';
                        this.validation.identificacion_imagenSeg = '';
                       
                        this.consultar();
                    }
                })
                .catch(error => {
                    Swal.fire('¡Error!', 'Todos los campos deben ser llenados', 'error');
                    if(error.response.data.errors?.nombre?.[0]){
                                this.validation.nombre = error.response.data.errors?.nombre?.[0];
                            }
                            if(error.response.data.errors?.tipo_identificacion?.[0]){
                                this.validation.tipo_identificacion = error.response.data.errors?.tipo_identificacion?.[0];
                            }
                            if(error.response.data.errors?.expedida_por?.[0]){
                                this.validation.expedida_por = error.response.data.errors?.expedida_por?.[0];
                            }
                            if(error.response.data.errors?.numero?.[0]){
                                this.validation.numero = error.response.data.errors?.numero?.[0];
                            }
                            
                            if(error.response.data.errors?.identificacion_imagen?.[0]){
                                this.validation.identificacion_imagen = error.response.data.errors?.identificacion_imagen?.[0];
                            }



                            if(error.response.data.errors?.nombreSeg?.[0]){
                                this.validation.nombreSeg = error.response.data.errors?.nombreSeg?.[0];
                            }
                            if(error.response.data.errors?.tipo_identificacionSeg?.[0]){
                                this.validation.tipo_identificacionSeg = error.response.data.errors?.tipo_identificacionSeg?.[0];
                            }
                            if(error.response.data.errors?.expedida_porSeg?.[0]){
                                this.validation.expedida_porSeg = error.response.data.errors?.expedida_porSeg?.[0];
                            }
                            if(error.response.data.errors?.numeroSeg?.[0]){
                                this.validation.numeroSeg = error.response.data.errors?.numeroSeg?.[0];
                            }
                            if(error.response.data.errors?.identificacion_imagenSeg?.[0]){
                                this.validation.identificacion_imagenSeg = error.response.data.errors?.identificacion_imagenSeg?.[0];
                            }

    
                });
            },
            consultar(){
                this.isLoading = true;
                var idcotizacion = localStorage.getItem('idcotizacion');
                
                axios.post(this.$rutaServer+'consultarRegistroTestigo',{idcotizacion:idcotizacion} )
                .then(response => {
                    if (response.status == 200) {
                        this.isLoading = false;
                        if(response.data.length > 0){
                            this.existeInformacion = true;
                        }
                        if(response.data.length == 1){
                            if(response.data[0].numerotestigo == 1){
                                this.form.nombre = response.data[0].nombre;
                                this.form.tipo_identificacion = response.data[0].tipo_identificacion;
                                this.form.expedida_por = response.data[0].expedida_por;
                                this.form.id = response.data[0].id;
                                this.form.numero = response.data[0].numero;

                                /*if(response.data[0].identificacion_imagen){
                                    this.imagePreview = this.$rutaImagenes+response.data[0].identificacion_imagen;
                                }*/
                                if (response.data[0].identificacion_imagen) {
                                    this.cargarTipoArchivo(
                                        response.data[0].identificacion_imagen,
                                        1
                                    );
                                }
                            }
                            else{
                                if(response.data[0].numerotestigo == 2){
                                    this.form.nombreSeg = response.data[0].nombreSeg;
                                    this.form.tipo_identificacionSeg = response.data[0].tipo_identificacionSeg;
                                    this.form.expedida_porSeg = response.data[0].expedida_porSeg;
                                    this.form.idSeg = response.data[0].idSeg;
                                    this.form.numeroSeg = response.data[0].numeroSeg;
                                    this.form.id = response.data[0].id;
                                    /*if(response.data[0].identificacion_imagen){
                                        this.imagePreview2 = this.$rutaImagenes+response.data[0].identificacion_imagen;
                                    }*/
                                   if (response.data[0].identificacion_imagen) {
                                        this.cargarTipoArchivo(
                                            response.data[0].identificacion_imagen,
                                            1
                                        );
                                    }
                                }
                            }
                        }
                        else if(response.data.length == 2){
                            this.form.nombre = response.data[0].nombre;
                            this.form.tipo_identificacion = response.data[0].tipo_identificacion;
                            this.form.expedida_por = response.data[0].expedida_por;
                            this.form.id = response.data[0].id;
                            this.form.numero = response.data[0].numero;

                            /*if(response.data[0].identificacion_imagen){
                                this.imagePreview = this.$rutaImagenes+response.data[0].identificacion_imagen;
                            }*/
                            if (response.data[0].identificacion_imagen) {
                                this.cargarTipoArchivo(
                                    response.data[0].identificacion_imagen,
                                    1
                                );
                            }
                            this.form.nombreSeg = response.data[1].nombreSeg;
                            this.form.tipo_identificacionSeg = response.data[1].tipo_identificacionSeg;
                            this.form.expedida_porSeg = response.data[1].expedida_porSeg;
                            this.form.idSeg = response.data[1].idSeg;
                            this.form.numeroSeg = response.data[1].numeroSeg;

                            /*if(response.data[1].identificacion_imagenSeg){
                                this.imagePreview2 = this.$rutaImagenes+response.data[1].identificacion_imagenSeg;
                            }*/
                           if (response.data[1].identificacion_imagenSeg) {
                                this.cargarTipoArchivo(
                                    response.data[1].identificacion_imagenSeg,
                                    2
                                );
                            }
                        }
                        else{

                        }
                        


                        

                    }
                })
                .catch(error => {
                    
                });
            }
        },
            
    };
    </script>